import { message, Modal } from "antd";
import { useContext } from "react";
import { Context } from "../index";
import MessageForm, { MessageData } from "./MessageForm";
import { useAntdTheme } from "antd-style";
import MessageService from "../services/MessageService";
import { AxiosError } from "axios";

type Props = {
  open: boolean;
};

export const ModalMessage = ({ open }: Props) => {
  const { authStore, modalStore } = useContext(Context);
  const { colorPrimary } = useAntdTheme();
  const handleOk = async (props: MessageData) => {
    const userId = authStore.user.id;
    try {
      const res = await MessageService.sendMessage(userId, props);
      message.success(res.data.message);
      modalStore.clearMessageModal();
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail);
      } else {
        console.log(e);
      }
    } finally {
      modalStore.showMessageModal(false);
    }
  };
  const handleCancel = () => {
    modalStore.showMessageModal(false);
  };

  return (
    <Modal
      open={open}
      title={"Send us a message"}
      className="modal-width-logo"
      footer={null}
      onCancel={handleCancel}
    >
      <MessageForm onOk={handleOk} onCancel={handleCancel} />
    </Modal>
  );
};
